import { type MouseEvent } from 'react'

import { Button } from '@loadsmart/miranda-react'

import { type Stop, getPickup, getDelivery } from 'core/domain/Stop'
import { formatLocation } from 'core/presenters/stopPresenter'
import { Icon } from 'core/ui/components/icon/Icon'
import { useSalesforceChatContext } from 'core/ui/contexts/SalesforceChatContext'
import { isString, join } from 'core/utils/string'

import { analytics } from 'legacy/utils/analytics'

import { getOfferType } from '../domain/OfferType'
import { formatOfferType } from '../presenters/offerTypePresenter'

export type OfferChatButtonProps = {
  refNumber?: string
  isLoadCandidate?: boolean
  isContracted?: boolean
  stops: Array<Stop>
  context?: string
  analyticsContext?: string
}

export function OfferChatButton({
  stops,
  refNumber,
  isContracted = false,
  isLoadCandidate = false,
  context,
  analyticsContext,
}: OfferChatButtonProps) {
  const { isChatEnabled, openChat, setRefNumber, sendMessage } = useSalesforceChatContext()

  if (!isChatEnabled) {
    return null
  }

  function handleClick(event: MouseEvent): void {
    event.preventDefault()

    const pickup = formatLocation(getPickup(stops))
    const delivery = formatLocation(getDelivery(stops))
    const offerType = formatOfferType(getOfferType(isContracted, isLoadCandidate))
    const text = `I would like some help with this ${offerType} Load! Going from: ${pickup} to ${delivery}.`

    setRefNumber(refNumber)
    openChat()
    sendMessage(text)

    analytics.track(
      join([analyticsContext, 'Load Offer / Open Chat'], ' / '),
      context ? { triggerContext: context } : undefined
    )
    analytics.tag([analyticsContext, 'Chat Requested for Load Offer'].filter(isString))
  }

  return (
    <Button type="button" variant="icon" onClick={handleClick}>
      <Icon name="chat" title="Start chat" size={20} />
    </Button>
  )
}
